// signInError — why a sign-in attempt ended without a session (FR-1.4, UR-4).
//
// The server redirects every failed sign-in back into the app as
// `/?signin_error=<kind>`; the client parses the query value at the boundary
// into this closed union and renders a plain message with a retry. Pure:
// shared vocabulary only, no I/O. Exposed as `@bilda/app/signInError`.
export { parseSignInError, signInErrorKinds, signInErrorParam, signInErrorRedirect, };
const signInErrorKinds = ["cancelled", "failed", "account_disabled"];
const signInErrorParam = "signin_error";
// Boundary parse: an unknown or absent value is "no error", never a guess.
const parseSignInError = (raw) => signInErrorKinds.find((kind) => kind === raw);
const signInErrorRedirect = (kind) => `/?${signInErrorParam}=${kind}`;
//# sourceMappingURL=signInError.js.map